module.exports = __webpack_public_path__ + "img/derby_460.274e2513.png";